import type { AnyNode, MustacheLiteral } from 'acorn'

const escapeRE = /\\/g

const escapeTplRE = /(\\*)`/g

const escapeTplFn = ($: string, $1: string) => ($1 === '' ? '\\`' : $)

export function compileLiteralPart(input: string) {
  return escapeBackticks(String(input).replaceAll(escapeRE, '\\\\'))
}

export function escapeBackticks(input: string) {
  return input.replaceAll(escapeTplRE, escapeTplFn)
}

export const compileLiteral = (node: MustacheLiteral) => {
  return `\`${escapeBackticks(String(node.raw).replaceAll(escapeRE, '\\\\'))}\``
}

export const isValuableNode = (node: AnyNode) => {
  if (node.type === 'Literal') {
    return node.raw !== 'null'
  }
  if (
    node.type === 'ObjectExpression' ||
    node.type === 'ArrayExpression' ||
    node.type === 'BinaryExpression'
  )
    return true
  return false
}

export const isEmptyNode = (node: AnyNode) => {
  if (node.type === 'Literal') {
    return node.raw === 'null'
  }
  if (node.type === 'Identifier') {
    return node.name === 'undefined'
  }
  return false
}

export function escapeRegExp(string: string) {
  return string
    .replaceAll(/[$()*+.?[\\\]^{|}]/g, String.raw`\$&`)
    .replaceAll('-', String.raw`\x2d`)
}
